import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showSuccessToast = (text) => {
  toast.success(text, {
    position: toast?.POSITION?.TOP_CENTER || "top-center",
    autoClose: 3000,
  });
};
export const showErrorToast = (text) => {
  toast.error(text, {
    position: toast?.POSITION?.TOP_CENTER || "top-center",
    autoClose: 3000,
  });
};
export function formatDate(dateString) {
  const date = new Date(dateString);

  // Format the date to "12 July 2024, 12:30 PM"
  const options = {
    weekday: "short", // e.g., "Mon"
    year: "numeric", // e.g., "2024"
    month: "long", // e.g., "July"
    day: "numeric", // e.g., "12"
    hour: "2-digit", // e.g., "12"
    minute: "2-digit", // e.g., "30"
    hour12: true, // 12-hour format with AM/PM
  };

  return date.toLocaleString("en-GB", options);
}
